import Grid from "@mui/material/Grid"
import InitiateSinglePaymentDropdown from "../../specific/payments/initiateSinglePayment";
import InitiateRequestFunds from "../../specific/payments/initiateRequestFunds";
import BankAccountCheckDeposits from "../checkDeposits/bankAccountCheckDeposits";
import BankAccountStatements from "../statements/bankAccountStatements";
import VirtualDebitCardView from "../card/virtualDebitCardView";
import BankAccountVerificationDoc from "../verificationDoc/bankAccountVerificationDoc";
import UploadTransactionsCsv from "../transactions/uploadTransactionsCsv";
import AccountHeaderFormatter from "./accountHeaderFormatter";
import BankAccountDetailsModal from "../modals/accountDetails";
import BalanceOverwriteButton from "../modals/BalanceOverwriteButton";


const ActionInfo = (props) => {
	return (
		<AccountHeaderFormatter
			title="Actions"
			body={
				<Grid container spacing={1}>
					{/* Left Section - First 5 Items */}
					<Grid item xs={12} md={6} display="flex" flexDirection="column">
						{!props.loading && props.bankAccountInfo && (
							<BankAccountDetailsModal
								beneficiaryDetails={props.beneficiaryInfo}
								accountDetails={props.bankAccountInfo}
								bankAccountId={props.bankAccountId}
							/>
						)}
						{!props.loading && props.bankAccountInfo && (
							<BalanceOverwriteButton
								accountDetails={props.bankAccountInfo}
								setBankAccountData={props.setBankAccountData}
								bankAccountId={props.bankAccountId}
							/>
						)}
						{!props.loading && props.bankAccountInfo && props.bankAccountInfo.source !== "MA" && (
							<InitiateSinglePaymentDropdown
								bankAccountId={props.bankAccountId}
								bankAccountInfo={props.bankAccountInfo}
								bankAccountSource={props.bankAccountInfo?.source}
								updateInternalTransactions={props.updateInternalTransactions}
								updateExternalTransactions={props.updateExternalTransactions}
								updatePaymentRequests={props.updatePaymentRequests}
							/>
						)}
						{!props.loading && props.bankAccountInfo?.has_ach_debit && props.bankAccountInfo.source !== "MA" && (
							<InitiateRequestFunds
								bankAccountId={props.bankAccountId}
								bankAccountInfo={props.bankAccountInfo}
								addAchDebitRequest={props.addAchDebitRequest}
								bankAccountSource={props.bankAccountInfo?.source}
							/>
						)}
						{!props.loading && props.bankAccountInfo && (
							<BankAccountCheckDeposits
								bankAccountId={props.bankAccountId}
								bankAccountInfo={props.bankAccountInfo}
								bankAccountSource={props.bankAccountInfo?.source}
								updateCheckDeposits={props.updateCheckDeposits}
							/>
						)}
						{props.bankAccountInfo && props.bankAccountInfo.source !== "MA" && (
							<BankAccountStatements
								bankAccountId={props.bankAccountId}
								bankAccountInfo={props.bankAccountInfo}
								hasStatements={props.bankAccountInfo?.has_statements}
								bankAccountSource={props.bankAccountInfo?.source}
							/>
						)}
					</Grid>

					{/* Right Section - Last 3 Items */}
					<Grid item xs={12} md={6} display="flex" flexDirection="column">
						{!props.loading && props.bankAccountInfo && (
							<VirtualDebitCardView
								bankAccountId={props.bankAccountId}
								bankAccountInfo={props.bankAccountInfo}
								cardInfo={props.bankAccountInfo?.virtual_debit_card_info}
								showVirtualDebitCard={props.showVirtualDebitCard}
							/>
						)}
						{!props.loading && props.bankAccountInfo && (
							<BankAccountVerificationDoc
								bankAccountId={props.bankAccountId}
								bankAccountInfo={props.bankAccountInfo}
								bankAccountSource={props.bankAccountInfo?.source}
							/>
						)}
						{props.bankAccountInfo?.source === "MA" && (
							<UploadTransactionsCsv bankAccountId={props.bankAccountId} setTransactionsTable={props.setTransactionsTable} />
						)}
					</Grid>
				</Grid>
			}
		/>
	);
};

export default ActionInfo;
